import { DateObject, useIntl } from '@capsicum/common';
import { useMemo } from 'react';

export const useWCPledgeActivityTabTexts = () => {
	const { $t } = useIntl();

	return useMemo(() => {
		const date = new DateObject();
		const formattedDate = date.format('Do MMMM');

		return {
			alertText: $t('worldChampionshipPledge.activityTab.alert'),
			cancelPledgeWarningModalTexts: {
				primaryButtonText: $t('worldChampionshipPledge.activityTab.cancelPledgeWarningModal.primaryButtonText'),
				secondaryButtonText: $t(
					'worldChampionshipPledge.activityTab.cancelPledgeWarningModal.secondaryButtonText'
				),
				subtitle: $t('worldChampionshipPledge.activityTab.cancelPledgeWarningModal.subtitle'),
				title: $t('worldChampionshipPledge.activityTab.cancelPledgeWarningModal.title')
			},
			noPledgesTexts: {
				subHeading: $t('worldChampionshipPledge.activityTab.noPledges.subHeading'),
				title: $t('worldChampionshipPledge.activityTab.noPledges.title')
			},
			summarySectionTexts: {
				chilizBonus: $t('worldChampionshipPledge.activityTab.summarySection.chilizBonus'),
				lastUpdated: $t('worldChampionshipPledge.activityTab.summarySection.lastUpdated', {
					refreshDate: formattedDate
				}),
				pledgedAmount: $t('worldChampionshipPledge.activityTab.summarySection.pledgedAmount'),
				title: $t('worldChampionshipPledge.activityTab.summarySection.title')
			},
			yourChilizSectionTexts: {
				bonusText: $t('worldChampionshipPledge.activityTab.yourChilizSection.bonusText'),
				claimableTitle: $t('worldChampionshipPledge.activityTab.yourChilizSection.claimableTitle'),
				claimButtonText: $t('worldChampionshipPledge.activityTab.yourChilizSection.claimButtonText'),
				claimedTitle: $t('worldChampionshipPledge.activityTab.yourChilizSection.claimedTitle'),
				noClaimablePledgesText: $t(
					'worldChampionshipPledge.activityTab.yourChilizSection.noClaimablePledgesText'
				),
				noClaimedPledgesText: $t('worldChampionshipPledge.activityTab.yourChilizSection.noClaimedPledgesText'),
				noUnstakingPledgesText: $t(
					'worldChampionshipPledge.activityTab.yourChilizSection.noUnstakingPledgesText'
				),
				refundReasonNotQualifiedText: $t(
					'worldChampionshipPledge.activityTab.yourChilizSection.refundReasonNotQualifiedText'
				),
				refundReasonUnstakeText: $t(
					'worldChampionshipPledge.activityTab.yourChilizSection.refundReasonUnstakeText'
				),
				refundText: $t('worldChampionshipPledge.activityTab.yourChilizSection.refundText'),
				title: $t('worldChampionshipPledge.activityTab.yourChilizSection.title'),
				totalText: $t('worldChampionshipPledge.activityTab.yourChilizSection.totalText'),
				unstakeTipnoteText: $t('worldChampionshipPledge.activityTab.yourChilizSection.unstakeTipnoteText'),
				unstakingTitle: $t('worldChampionshipPledge.activityTab.yourChilizSection.unstakingTitle')
			},
			yourPledgeSectionTexts: {
				allTeamsFooter: $t('worldChampionshipPledge.activityTab.yourPledgeSection.allTeamsFooter'),
				pledgedAmountHeader: $t('worldChampionshipPledge.activityTab.yourPledgeSection.pledgedAmountHeader'),
				stakeMore: $t('worldChampionshipPledge.activityTab.yourPledgeSection.stakeMore'),
				teamHeader: $t('worldChampionshipPledge.activityTab.yourPledgeSection.teamHeader'),
				title: $t('worldChampionshipPledge.activityTab.yourPledgeSection.title'),
				unstake: $t('worldChampionshipPledge.activityTab.yourPledgeSection.unstake')
			}
		};
	}, [$t]);
};
